import * as $ from 'jquery';
import * as _ from 'underscore';
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import { on, Options } from "../../utils/decorators";


@Options({
    template: false,
    el: ".js-form-group",
    ui: {
        clearInputButton: ".js-btn-clear-x",
    }
})

export default class FormViewController extends Marionette.View<Backbone.Model>{
    constructor() {
        super();
    }

    onRender() {
        console.log("form viewcontroller rendered");
    }

    // -------------------------------------
    // events
    // -------------------------------------

    @on("click @ui.clearInputButton")
    onClearInputBtnClick(JQueryEventObject: any) {
        const $siblingInput = $(JQueryEventObject.currentTarget).siblings("input"); // get sibling input
        $siblingInput.val("");
        console.log(`clicked`);
    }

    // -------------------------------------
    // functions
    // -------------------------------------

    // stub
}



// WEBPACK FOOTER //
// ./django/project/@static/@modules/shared/form-clear/controller.ts